var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"d-flex d-flex-c flex-1"},[_c('span',{staticClass:"empty-library mb-1 mt-05"}),_c('span',{staticClass:"empty-text"},[_c('p',[_vm._v("You are currently not a member of any team")]),_c('p',[_vm._v("Click on "),_c('b',[_vm._v("\"Create team\"")]),_vm._v(" and invite your team members.")])])])])
}]

export { render, staticRenderFns }